"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Badge = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Color = require("./Color");

var _Element = require("./Element");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */

/**
 * Badge
 *
 * Badges a parent component
 *
 * @component
 * @category Atoms
 */
var Badge = function Badge(props) {
  var attr = Object.assign({}, props, {
    color: null,
    position: null,
    border: null,
    className: "BadgeInner"
  });

  if (props.className) {
    attr.className += " " + props.className;
  } // background


  if (props.color) {
    attr.background = props.color;
  } // border


  if (props.border === _Color.Color.None) {
    // add no border
    attr.className += " border-none";
  } else if (props.border) {
    attr.className += " border-".concat(props.border);
  } else {
    attr.className += " border-white2-color";
  } // position


  if (props.position) {
    attr.className += " ".concat(props.position);
  } else {
    attr.className += " ".concat(Badge.Position.BottomRight);
  }

  var styles = props.styles ? props.styles : {};
  styles.width = props.size;
  styles.height = props.size;
  attr.style = styles;
  return /*#__PURE__*/_react.default.createElement(_Element.Element, {
    className: "Badge"
  }, /*#__PURE__*/_react.default.createElement(_Element.Element, attr, props.children));
};

exports.Badge = Badge;
Badge.Position = {
  TopLeft: "top-left",
  TopRight: "top-right",
  BottomRight: "bottom-right",
  BottomLeft: "bottom-left",
  Inline: "inline"
};
Badge.propTypes = {
  /** The size of the badge */
  size: _propTypes.default.number.isRequired,

  /** The color of the badge */
  color: _propTypes.default.string,

  /** The position of the badge in its parent, defaults to Badge.BottomRight */
  position: _propTypes.default.oneOf(Object.keys(Badge.Position).map(function (c) {
    return Badge.Position[c];
  })),

  /** The border color the badge, defaults to Color.White2 */
  border: _propTypes.default.oneOf(Object.keys(_Color.Color).map(function (c) {
    return _Color.Color[c];
  }))
};